import React from "react";
import { Outlet, Navigate } from "react-router-dom";

import { useAuth } from "hooks/useAuth";
import NavBar from "./Navbar/Navbar";
import Loading from "./Loading";

// Компонент-обгортка для захищених маршрутів
const AppLayout = () => {
  const { isAuthenticated, loading } = useAuth();

  // Поки йде перевірка сесії, показуємо екран завантаження
  if (loading) {
    return <Loading />;
  }

  // Якщо користувач не авторизований, перенаправляємо його на сторінку входу
  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  return (
    <>
      <NavBar />
      <main>
        <Outlet />
      </main>
    </>
  );
};

export default AppLayout;
